import { Schema as S } from "effect";
const Limits = S.Struct({ records: S.Number, entries: S.Number });
export const Subscription = S.Struct({
	plan: S.Struct({
		priceCents: S.Number,
		currency: S.String,
		interval: S.Literal("month"),
		free: Limits,
		paid: Limits,
	}),
	enabled: S.Boolean,
	canManage: S.Boolean,
	status: S.Literals([
		"free",
		"pending",
		"active",
		"trialing",
		"scheduled_cancel",
		"past_due",
		"unpaid",
		"paused",
		"canceled",
		"expired",
	]),
	paid: S.Boolean,
	currentPeriodEnd: S.NullOr(S.String),
	canOpenPortal: S.Boolean,
});
export type Subscription = typeof Subscription.Type;
export const BillingSession = S.Struct({ url: S.String });
